export default () => {
  // pageTop エレメントの取得
  const pageTop = document.getElementById('pageTop');

  // pageTop エレメントの存在チェック
  if (!pageTop) {
    console.error('No element with ID \'pageTop\' found.');
    return;
  }

  const VISIBILITY_SCROLL_OFFSET = 400;
  let ticking = false;
  let isVisible = false;

  // 上部にスクロールする関数
  const scrollToTop = () => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  };

  // スクロール時のボタン可視性チェック
  const checkScrollForVisibility = (element, offset) => {
    const shouldBeVisible = window.scrollY > offset;

    if (shouldBeVisible !== isVisible) {
      element.classList.toggle('is-view', shouldBeVisible);
      isVisible = shouldBeVisible;
    }
  };

  // スクロールイベントのリスナー
  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;

      window.requestAnimationFrame(() => {
        checkScrollForVisibility(pageTop, VISIBILITY_SCROLL_OFFSET);
        ticking = false;
      });
    }
  });

  // ページトップボタンのクリックで上部にスクロール
  pageTop.addEventListener('click', scrollToTop);
};
